export default __webpack_public_path__ + "6d4882493c041747991e1c4df877eda3.png";